import { get } from 'app/utils/axios/kheti'

interface Props {
  filterPage: 'vendor' | 'change_request' | 'approver'
}

const fetchFilterData = async (filterPage: Props['filterPage']) => {
  const data = {
    filters: [
      {
        key: 'status',
        type: 'checkbox',
        options: ['PENDING', 'APPROVED', 'REJECTED'],
      },
      {
        key: 'date',
        type: 'date',
      },
    ],
  }
  try {
    const url = `/approvals/v1/filters`
    const response = await get<Response>(url, {
      app_code: process.env.APP_CODE,
      filter_page: filterPage,
    })
    return response
  } catch (e) {
    return null
  }
}

export default fetchFilterData
